"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCheckoutForDeliveryPath = exports.getCheckoutForDelivery = void 0;
const utils_1 = require("@invivodf/utils");
const utils_2 = require("../../../utils");
const getCheckoutForDelivery = (client) => async ({ checkoutId }) => {
    try {
        const response = await client.get((0, exports.getCheckoutForDeliveryPath)(checkoutId));
        return utils_1.Result.success(response.data);
    }
    catch (error) {
        if ((0, utils_2.isFunctionalApiError)(error)) {
            return utils_1.Result.failure({
                code: error.body.code,
                message: error.body.message
            });
        }
        throw error;
    }
};
exports.getCheckoutForDelivery = getCheckoutForDelivery;
const getCheckoutForDeliveryPath = (checkoutId) => `/v2/bff/appro/checkouts/${checkoutId}/for-delivery`;
exports.getCheckoutForDeliveryPath = getCheckoutForDeliveryPath;
